import { updateCell } from "./update-cell";

export function clearColHover(scenegraph, col, rowOrigin, selectRanges, selectMode) {
    const table = scenegraph.table;
    for (let row = 0; row < table.columnHeaderLevelCount; row++) updateCell(scenegraph, col, row);
    const cellGroup = scenegraph.getColGroup(col);
    return null == cellGroup || cellGroup.addUpdateBoundTag(), !0;
}

export function updateColHover(scenegraph, col, rowOrigin, selectRanges, selectMode, singleStyle) {
    const table = scenegraph.table;
    for (let row = 0; row < table.columnHeaderLevelCount; row++) updateCell(scenegraph, col, row);
    const cellGroup = scenegraph.getColGroup(col);
    return null == cellGroup || cellGroup.addUpdateBoundTag(), !0;
}
//# sourceMappingURL=col.js.map
